// src/api/equipmentPricesApi.js
import axios from "axios";

const BASE = `${process.env.REACT_APP_SERVER_URL}/api/equipmentPrices`;

/** Fetch all medical equipment prices (public, no auth). */
export async function fetchEquipmentPrices() {
    const { data } = await axios.get(BASE);
    return data;
}

/** Fetch admin status with per-item details (requires admin auth). */
export async function fetchEquipmentPriceStatus(token) {
    const { data } = await axios.get(`${BASE}/status`, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return data;
}

/** Trigger a manual price refresh (requires admin auth). */
export async function triggerEquipmentPriceRefresh(token) {
    const { data } = await axios.post(
        `${BASE}/refresh`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
    );
    return data;
}

/** Manually set an equipment price (requires admin auth). */
export async function updateEquipmentPrice(equipmentId, price, token) {
    const { data } = await axios.patch(
        `${BASE}/${equipmentId}`,
        { price },
        { headers: { Authorization: `Bearer ${token}` } }
    );
    return data;
}
